/*
 * Ryan O'Dowd
 * 2025-08-29
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import Button from '@components/common/Button';
import Dialog from '@components/common/Dialog';
import FormControl from '@components/common/FormControl';
// @TODO: import Select from '@components/common/Select';
import Text from '@components/common/Text';
import TextInput from '@components/common/TextInput';
import {
  View,
} from 'react-native';
import {
  createNewSchool,
} from '@utils/store/actions';
import getStyles from './styles';
import hooks from '@hooks';

const NewSchoolDialog = (props: NewSchoolDialogProps) => {
  const styles = hooks.useStyles(getStyles);
  const dispatch = hooks.useTypedDispatch();
  const i18n = hooks.useI18n();
  const navigation = hooks.useNavigation();

  const [_schoolName, setSchoolName] = useState('');
  const [_classroomName, setClassroomName] = useState('');
  const [_teacherName, setTeacherName] = useState('');
  // @TODO: const [_role, setRole] = useState('teacher');

  const [_validationErrors, setValidationErrors] = useState({
    schoolName: false,
    classroomName: false,
    teacherName: false,
  });

  const user = hooks.useTypedSelector((state) => state.userMasqueradingAs || state.oakUser);

  return (
    <Dialog
      visible={props.isOpen}
      onDismiss={() => props.onClose()}
    >
      <Dialog.Title>{i18n('createNewSchoolAccount')}</Dialog.Title>
      <Dialog.Content>
        {/* @TODO: whether or not user has existing account, they must sign in before seeing the form below */}

        {/* @TODO:
        <Select
          label='Role'// @TODO: i18n
          options={[
            {
              label: 'Teacher',
              value: 'teacher',
            },
            {
              label: 'Administrator',
              value: 'administrator',
            },
          ]}
          value={_role}
          onChange={(value) => setRole(value)}
        />{/* @TODO: explain these roles /}

        {_role === 'admin' &&
          <Text>TODO: checkbox/textinput for teacher email address? (checkbox for "is me")</Text>
        }
        */}

        <TextInput
          value={_schoolName}
          mode='outlined'
          onChangeText={(text) => setSchoolName(text)}
          label='School name'
          isAlert={_validationErrors.schoolName}
        />

        <TextInput
          value={_classroomName}
          mode='outlined'
          onChangeText={(text) => setClassroomName(text)}
          placeholder='e.g. "6th Grade Bible"'
          label='Classroom name'
          isAlert={_validationErrors.classroomName}
        />

        {props.isAdmin &&
          <FormControl
            addPadding={true}
            label='Admin options'
            style={styles.adminSettingsWrapper}
          >
            <View style={styles.adminOptionsInner}>
              <Text>TODO: set admin/teacher</Text>
            </View>
          </FormControl>
        }

        <TextInput
          value={_teacherName}
          mode='outlined'
          onChangeText={(text) => setTeacherName(text)}
          placeholder='e.g. "Mrs. Smith"'
          label='Teacher display name'
          isAlert={_validationErrors.teacherName}
        />
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          mode='text'
          onPress={() => props.onClose()}
        >
          {i18n('cancel')}
        </Button>
        <Button
          onPress={() => {
            const currErrorStatuses = {
              schoolName: !_schoolName,
              classroomName: !_classroomName,
              teacherName: !_teacherName,
            };
            setValidationErrors(currErrorStatuses);
            if (Object.values(currErrorStatuses).some(Boolean)) {
              return;
            }

            if (!user) {
              // @TODO: login and then dispatch the create new school
              const params = new URLSearchParams(location.search);
              params.set('isNewSchoolDialogOpen', '1');
              params.set('schoolName', _schoolName);
              params.set('classroomName', _classroomName);
              params.set('teacherName', _teacherName);
              const search = `?${params.toString()}`;

              navigation.navigate(`/app?redirectUrl=${encodeURIComponent(location.pathname + search)}`);
            } else {
              // @TODO: it seems like there's a race condition here...sometimes the post doesn't have a valid jwt...not sure if this is only an issue on localhost, though...
              dispatch(createNewSchool(_schoolName, _classroomName, _teacherName, (schoolId) => {
                props.onClose();
                navigation.navigate(`/schools/${schoolId}`);
              }));
            }
          }}
        >
          {i18n('save')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

class NewSchoolDialogProps {
  isOpen: boolean;
  onClose: () => void;

  isAdmin?: boolean;
};

export default NewSchoolDialog;
